var map = {
	"./login/password.svg": "onv1",
	"./login/user.svg": "ahwh",
	"./navibar/person.svg": "T3rQ",
	"./sidebar/app.svg": "XX1k",
	"./sidebar/connect.svg": "sHZb",
	"./sidebar/license.svg": "nIaf",
	"./sidebar/utilIcon.svg": "4okP",
	"./sidebar/yilan.svg": "35R8",
	"./sidebar/zhuji.svg": "0rWn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DwwP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg \.svg$
// module id = DwwP
// module chunks = 73